import OrganizationInfo from "./OrganizationInfo";
export default OrganizationInfo;
